import React, { createContext, useContext } from 'react';

interface PageContextValue {
  pageId: string | null;
  siteId: string | null;
  pageSlug: string | null;
}

const PageContext = createContext<PageContextValue>({
  pageId: null,
  siteId: null,
  pageSlug: null,
});

// eslint-disable-next-line react-refresh/only-export-components
export const usePageContext = () => {
  return useContext(PageContext);
};

interface PageContextProviderProps {
  children: React.ReactNode;
  pageId: string | null;
  siteId?: string | null;
  pageSlug?: string | null;
}

export const PageContextProvider: React.FC<PageContextProviderProps> = ({
  children,
  pageId,
  siteId = null,
  pageSlug = null,
}) => {
  return (
    <PageContext.Provider value={{ pageId, siteId, pageSlug }}>{children}</PageContext.Provider>
  );
};
